module.exports = __webpack_public_path__ + "img/logo.0cec90e2.png";